import clsx from "clsx";
import { LandingCtas } from "./LandingCtas";

export const LandingCtaBar = ({ data }) => {
  return (
    <section className="section-layout">
      <div
        className={clsx(
          "LandingCtaBar",
          data?.fields?.button_align && `LandingCtaBar-align-${data?.fields?.button_align}`,
        )}
      >
        {data?.fields?.label && <h3>{data?.fields?.label}</h3>}
        {data?.fields?.ctas && <LandingCtas ctas={data?.fields?.ctas} />}
      </div>
    </section>
  );
};
